import { Spinner } from "../Loader/Spinner";

export const LoadableLoader = () => (
    <div className="d-flex align-items-center justify-content-center flex-1">
        <Spinner/>
    </div>
)
